import {
  redrawFragment,
  LitheElement,
  LitheFC,
} from '@wheelbox/lithejs-engine';
import { withCurrentLanguage } from '@wheelbox/lithejs-i18n';

import { apiFetch } from '@lib/api';
import SearchModalContent from './search-modal-content';

import { SearchResult } from './types';

const SearchModal: LitheFC = ({
  id = 'search-modal',
  testId = 'search-modal',
}) => {
  const lng = withCurrentLanguage();

  let searchString = '';
  let isMatchCase = false;
  let isSearching = false;
  let searchResults: SearchResult[] = [];

  const onInputHandler = (value: string) => {
    searchString = value;
  };

  const onKeyPressHandler = async (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (searchString.trim().length > 2) {
        isSearching = true;

        redrawFragment(id);

        const response = await apiFetch(
          `/search?lng=${lng}&string=${encodeURIComponent(
            searchString
          )}&match_case=${isMatchCase ? 1 : 0}`
        );

        searchResults = await response.json();
        isSearching = false;
      }

      redrawFragment(id);
      document.getElementById(`${id}-input-input-field`)?.focus();
    }
  };

  const onToggleMatchCaseHandler = () => {
    isMatchCase = !isMatchCase;

    redrawFragment(`${id}-input`);
  };

  return (): LitheElement<'div'> => [
    'div',
    { id, 'data-testid': testId, class: 'min-w-80' },
    () =>
      SearchModalContent({
        id: `${id}-content`,
        searchString,
        isMatchCase,
        isSearching,
        searchResults,
        onInput: onInputHandler,
        onKeyPress: onKeyPressHandler,
        onToggleMatchCase: onToggleMatchCaseHandler,
      }),
  ];
};

export default SearchModal;
